var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.doShowDialog
    ? _c(
        "div",
        {
          staticClass: "confirmation-popup survey-popup",
          class: `${
            _vm.$route.path.startsWith("/gop/") ? "gop-modal" : "drc-modal"
          }`
        },
        [
          _c(
            "div",
            {
              staticClass: "confirmation-dialog",
              attrs: {
                "data-aos": "fade-up",
                "data-aos-anchor-placement": "center-bottom",
                "data-aos-duration": "400"
              }
            },
            [
              _c("div", { staticClass: "confirmation-content" }, [
                _c("h3", [_vm._v(_vm._s(_vm.$t("common.surveyQuestions")))]),
                _c(
                  "div",
                  { staticClass: "survey-container" },
                  [
                    _vm._l(_vm.questions, function(question, idx) {
                      return [
                        question.answerType === "MULTIPLE"
                          ? _c(
                              "div",
                              {
                                key: "question" + idx + question.id,
                                staticClass: "question question-multiple"
                              },
                              [
                                _c("div", { staticClass: "question-text" }, [
                                  _c(
                                    "span",
                                    { staticClass: "question-text-span" },
                                    [_vm._v(_vm._s(question.question))]
                                  )
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "question-options question-options-multiple"
                                  },
                                  [
                                    _vm._l(question.drcSurveyAnswers, function(
                                      option,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key:
                                            "answer" + index + idx + option.id,
                                          staticClass: "option",
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleOptions(
                                                option,
                                                question
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: question.answer,
                                                expression: "question.answer"
                                              }
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              value: option.id,
                                              checked: Array.isArray(
                                                question.answer
                                              )
                                                ? _vm._i(
                                                    question.answer,
                                                    option.id
                                                  ) > -1
                                                : question.answer
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a = question.answer,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = option.id,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        question,
                                                        "answer",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        question,
                                                        "answer",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    question,
                                                    "answer",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _c("label", [
                                            _vm._v(_vm._s(option.answer))
                                          ])
                                        ]
                                      )
                                    }),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: question.comment,
                                          expression: "question.comment"
                                        }
                                      ],
                                      domProps: { value: question.comment },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            question,
                                            "comment",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  2
                                )
                              ]
                            )
                          : _vm._e(),
                        question.answerType === "SINGLE"
                          ? _c(
                              "div",
                              {
                                key: "question" + idx + question.id,
                                staticClass: "question question-single"
                              },
                              [
                                _c("div", { staticClass: "question-text" }, [
                                  _c(
                                    "span",
                                    { staticClass: "question-text-span" },
                                    [_vm._v(_vm._s(question.question))]
                                  )
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "question-options question-options-single"
                                  },
                                  _vm._l(question.drcSurveyAnswers, function(
                                    option,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: "answer" + index + idx + option.id,
                                        staticClass: "option",
                                        on: {
                                          click: function($event) {
                                            return _vm.toggleOptions(
                                              option,
                                              question
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: question.answer,
                                              expression: "question.answer"
                                            }
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: option.id,
                                            checked: _vm._q(
                                              question.answer,
                                              option.id
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                question,
                                                "answer",
                                                option.id
                                              )
                                            }
                                          }
                                        }),
                                        _c("label", [
                                          _vm._v(_vm._s(option.answer))
                                        ])
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          : _vm._e(),
                        question.answerType === "TEXT"
                          ? _c(
                              "div",
                              {
                                key: "question" + idx + question.id,
                                staticClass: "question question-textarea"
                              },
                              [
                                _c("div", { staticClass: "question-text" }, [
                                  _c(
                                    "span",
                                    { staticClass: "question-text-span" },
                                    [_vm._v(_vm._s(question.question))]
                                  )
                                ]),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: question.comment,
                                      expression: "question.comment"
                                    }
                                  ],
                                  domProps: { value: question.comment },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        question,
                                        "comment",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            )
                          : _vm._e()
                      ]
                    }),
                    _c(
                      "div",
                      { staticClass: "confirmation-dialog-button-container" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "confirmation-modal-button cancel",
                            on: { click: _vm.closeSurvey }
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "confirmation-modal-button",
                            class: _vm.isEverythingSelected() ? "" : "disabled",
                            on: { click: _vm.submitCurrentSurvey }
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("common.submit")) + " ")]
                        )
                      ]
                    )
                  ],
                  2
                )
              ])
            ]
          ),
          _c("div", { class: "confirmation-popup-backdrop" })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }